import { Box, styled } from "@material-ui/core";
import { EPOCUS_PRIMARY, EPOCUS_WHITE, rem } from "./epocus-palette";

const Root = styled(Box)({
  borderRadius: "50%",
  backgroundColor: EPOCUS_PRIMARY,
  color: EPOCUS_WHITE,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: rem(14),
  fontWeight: 700,
  flexShrink: 0,
  userSelect: "none",
});

const getInitials = (name: string | undefined): string => {
  if (!name) return "?";
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

export const EpocusAvatar: FC<{ name?: string; size?: number }> = ({
  name,
  size = 32,
}) => <Root style={{ width: size, height: size }}>{getInitials(name)}</Root>;
